import { APIResponse } from 'types/Request';
import { getCookie } from 'helpers';
import config from 'config';
import { Partidos } from 'types/Partidos';

export async function getPartidos(provinciaId: number | undefined): Promise<Partidos[]> {
  try {
    const url = new URL(`${ config.baseUrl }/partidos`);

    if (provinciaId !== undefined) {
      url.searchParams.append('provincia_id', provinciaId.toString());
    }

    type Response = APIResponse<Partidos[]>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      throw new Error('Ocurrió un problema de conexión al momento de intentar recuperar los partidos. ');
    }

    const content = await response.json() as Response;
    if (content.status !== 'ok' || !content.payload) {
      throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar los partidos. ');
    }

    return content.payload;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
